

























































































































import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { Action, Getter, Mutation } from 'vuex-class';
import Draggable from 'vuedraggable';
import { UpdateBotFlowsPriorityViewModel } from '@/features/bots/models/request/updateBotFlowsPriorityViewModel';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import Modal from '@/shared/components/Modal.vue';
import { AvailableTriggers, FlowViewModel } from '@/features/bots/models/designer';
import Toast from '@/shared/services/toast';
import { exportFlowHelper } from '@/features/bots/services/exportFlow';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import DragIcon from '@/shared/components/DragIcon.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import CloneIcon from 'vue-material-design-icons/ContentCopy.vue';
import ExportIcon from 'vue-material-design-icons/Export.vue';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import { LOAD_FLOWS } from '@/store/bot-designer/actionTypes';
import AddFlowModal from '@/shared/components/AddFlowModal.vue';
import { flowsApi } from '@/features/bots/services/flows';
import appInsights from '@/shared/services/appInsights';
import { BOT_STUDIO_ENABLED, NLP_ENABLED } from '@/store/app/featureTypes';
import { SET_FLOWS } from '@/store/bot-designer/mutationTypes';

@Component({
	components: {
		Modal,
		PageHeader,
		LoadingSpinner,
		Draggable,
		DropDownMenu,
		DragIcon,
		HelpIcon,
		CloneIcon,
		ExportIcon,
		DeleteIcon,
		AddFlowModal
	}
})
export default class BotFlows extends Vue {
	public loading: boolean = false;
	public showModal: boolean = false;
	public showDeleteModal: boolean = false;
	public flowName: string = '';
	public flowToDelete: FlowListItemViewModel;
	public botFlows: FlowListItemViewModel[] = [];

	@Getter public isWorkspaceFeatureEnabled!: (key: string) => boolean;
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Action(LOAD_FLOWS) public loadFlows: any;
	@Mutation(SET_FLOWS) public setFlows: (flows: FlowListItemViewModel[]) => void;

	public $refs: {
		importFlowButton: any
	};

	public flowPriorityTooltip = `Order your flows by priority. <br/><br/>
	If multiple flows share the same trigger conditions, the one with the highest priority will be shown to visitors. <br/><br/>
	If none of the flows are triggered, a bot task will respond instead.`;

	public async mounted() {
		await this.getBotFlows();
	}

	public async updatePriorities() {
		this.setPriorities();
		const request = this.createUpdateFlowsPrioritiesRequest();
		const updateBotFlows: UpdateBotFlowsPriorityViewModel = {
			flows: request
		};
		await flowsApi.updateFlows(this.currentWorkspace.id, updateBotFlows);
		this.setFlows(this.botFlows);
	}


	public addFlow() {
		this.showModal = true;
		this.flowName = '';
	}

	public chooseFlow(flow: FlowListItemViewModel, created = false) {
		this.$router.push({ name: 'bots-flow-designer', params: { flowId: flow.id }, query: { created: created.toString() } });
	}

	public onFileChange(event: any) {
		appInsights.trackEvent({ name: 'Import flow clicked' }, { workspaceId: this.currentWorkspace.id });
		const files = event.target.files;
		if (!files.length) {
			Toast.showError('No file selected');
			throw new Error('No file selected');
		}
		const file = event.target.files[0];
		this.handleFlowFile(file);
	}

	public handleFileLoad(event: any) {
		try {
			const botFlowAsJson = JSON.parse(event.target.result);
			this.importFlow(this.currentWorkspace.id, botFlowAsJson);
		} catch (e) {
			Toast.showError('The file must contain valid JSON');
		}
	}

	public async deleteFlow(flow: FlowListItemViewModel) {
		try {
			const fullFlowDetails = await flowsApi.getFlow(this.currentWorkspace.id, flow.id);
			if (!fullFlowDetails) {
				Toast.showError(`Unable to delete ${flow.name}`);
				return;
			}

			if (this.isTransitionedTo(fullFlowDetails)) {
				Toast.showError('Cannot delete a flow that is transitioned to by another flow or FAQ');
			} else {
				this.flowName = '';
				this.flowToDelete = flow;
				this.showDeleteModal = true;
			}
		} catch {
			Toast.showError(`Unable to delete ${flow.name}`);
		}
	}

	public async cloneFlow(flow: FlowListItemViewModel, index: number) {
		try {
			appInsights.trackEvent({ name: 'Clone flow clicked' }, { workspaceId: this.currentWorkspace.id, flowId: flow.id });
			const clonedFlow = await flowsApi.cloneFlow(this.currentWorkspace.id, flow.id);
			this.insertInBotFlows(index + 1, clonedFlow);
			await this.updatePriorities();
			Toast.showSuccess('Successfully cloned flow');
		} catch {
			Toast.showError('Error duplicating flow');
		}
	}

	public openFileSelector() {
		this.$refs.importFlowButton.click();
	}

	public async deleteFlowConfirm() {
		appInsights.trackEvent({ name: 'Delete flow clicked' });
		this.showDeleteModal = false;
		try {
			await flowsApi.deleteFlow(this.currentWorkspace.id, this.flowToDelete.id);
			this.botFlows = this.botFlows.filter(botflow => botflow.id !== this.flowToDelete.id);
			this.setFlows(this.botFlows);
			Toast.showSuccess(`Successfully deleted ${this.flowToDelete.name}`);
		} catch (e) {
			Toast.showError(`Unable to delete ${this.flowToDelete.name}`);
		}
	}

	public getTriggerDescription(flow: FlowListItemViewModel) {
		const trigger = this.getTriggerItem(flow);
		if (!trigger) {
			return 'None';
		}
		return trigger.description;
	}

	public getTriggerIcon(flow: FlowListItemViewModel) {
		const trigger = this.getTriggerItem(flow);
		if (!trigger) {
			return '';
		}
		return trigger.icon;

	}

	public async exportFlow(flow: FlowListItemViewModel) {
		try {
			await exportFlowHelper.exportFlow(this.currentWorkspace.id, flow.id);
		} catch (e) {
			Toast.showError(`There was a problem exporting ${flow.name}`);
		}
	}

	public calculatePercentage(value: number, total: number) {
		if (!total) {
			return 0;
		}
		return Math.round((value / total) * 100);
	}

	public get botStudioEnabled() {
		return this.isWorkspaceFeatureEnabled(BOT_STUDIO_ENABLED);
	}

	private createUpdateFlowsPrioritiesRequest() {
		return this.botFlows.map(flow => ({ id: flow.id, priority: flow.priority }));
	}

	private insertInBotFlows(index: number, flow: FlowListItemViewModel) {
		this.botFlows.splice(index, 0, flow);
	}

	private getTriggerItem(flow: FlowListItemViewModel) {
		if (flow.triggers.length === 0) {
			return null;
		}

		return AvailableTriggers.get(flow.triggers[0]);
	}

	private handleFlowFile(file: any) {
		if (file.type === 'application/json') {
			const reader = new FileReader();
			reader.onload = this.handleFileLoad;
			reader.readAsText(file);
		} else {
			Toast.showError('File must be JSON');
		}
	}


	private async importFlow(botId: string, botFlow: string) {
		try {
			const importedFlow = await flowsApi.importFlow(botId, { flow: botFlow });
			this.botFlows.push(importedFlow);
			this.$router.push({ name: 'bots-flow-designer', params: { flowId: importedFlow.id } });
			Toast.showSuccess('File imported successfully');
		} catch (e: any) {
			if (e.status === 409) {
				Toast.showError(e.message);
				return;
			}
			Toast.showError('The Flow you imported is not valid');
		}
	}

	private setPriorities() {
		for (let i = 0; i < this.botFlows.length; i++) {
			this.botFlows[i].priority = this.botFlows.length - i;
		}
	}

	private async getBotFlows() {
		this.loading = true;
		try {
			const botFlowDataPromise = this.loadFlows(true);
			const botFlows: FlowListItemViewModel[] = await botFlowDataPromise;
			botFlows.sort((first, second) => second.priority - first.priority);
			this.botFlows = botFlows;
		} finally {
			this.loading = false;
		}
	}

	private isTransitionedTo(fullFlowDetails: FlowViewModel) {
		return this.hasFlowParent(fullFlowDetails) || this.hasAnswerParent(fullFlowDetails);
	}

	private hasFlowParent(fullFlowDetails: FlowViewModel) {
		return fullFlowDetails.parentFlows.length > 0;
	}

	private hasAnswerParent(fullFlowDetails: FlowViewModel) {
		return fullFlowDetails.parentAnswers.length > 0;
	}
}
